import React from 'react';
import { ThumbsUp } from 'lucide-react';
interface Comment {
  id: number;
  name: string;
  image: string;
  time: string;
  content: string;
  likes: number;
  isAuthor?: boolean;
  replies?: Comment[];
}
const comments: Comment[] = [{
  id: 1,
  name: 'Wilma Patterson',
  image: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  time: '41 min',
  content: "Can anybody vouch for this? I'm skeptical about trying another supplement.",
  likes: 6,
  replies: [{
    id: 11,
    name: 'Linda Morrison',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    time: '18 min',
    content: "Hey Wilma... It's fantastic! I used to feel like my legs were filling with cement by mid-afternoon. These Nymera softgels have completely changed that. I've been dealing with heavy legs for years, and the difference I feel now is unbelievable. Hopefully, it will help you too.",
    likes: 12
  }]
}, {
  id: 2,
  name: 'Doris Chen',
  image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  time: '1h',
  content: "I bought mine at full price, and now they're 30% off? That's not fair!",
  likes: 8
}, {
  id: 3,
  name: 'Margaret Foster',
  image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  time: '1h',
  content: "Can I take this if I'm on blood pressure medication?",
  likes: 3,
  replies: [{
    id: 31,
    name: 'Dr. Maria Castellanos',
    image: 'https://cdn.magicpatterns.com/uploads/h6aJiR4XXiJRW5ri8NK5g7/ChatGPT_Image_5_Φεβ_2026,_04_04_25_μ.μ..png',
    time: '45 min',
    content: "Hi Margaret - Always check with your doctor first, especially if you're on any medications. Some of the ingredients can interact with blood thinners, so it's important to get clearance from your healthcare provider before starting.",
    likes: 15,
    isAuthor: true
  }]
}, {
  id: 4,
  name: 'Skyler Davis',
  image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  time: '2h',
  content: 'How long does shipping take??',
  likes: 2,
  replies: [{
    id: 41,
    name: 'Marie Campbell',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    time: '24 min',
    content: 'Hey Skyler, got mine after about 5 business days.',
    likes: 4
  }]
}, {
  id: 5,
  name: 'Leonard Boyd',
  image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  time: '3h',
  content: "I bought these for my wife, who was constantly dealing with heavy, swollen legs no matter how much she elevated them or wore compression. She's been feeling drained for months. In just a couple of weeks, she's noticeably more energized and getting through the day much easier.",
  likes: 9
}, {
  id: 6,
  name: 'Emma Richardson',
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  time: '4h',
  content: 'These softgels are what you need instead of expensive massage appointments every week.',
  likes: 5
}, {
  id: 7,
  name: 'Louis Martinez',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  time: '6h',
  content: "Wow, these look amazing! I've just ordered a bottle now!",
  likes: 6,
  replies: [{
    id: 71,
    name: 'Alfred Johnson',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    time: '8h',
    content: 'Did you order it? How long does it take to get it?',
    likes: 2
  }, {
    id: 72,
    name: 'Editha Cruz',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    time: '1h',
    content: 'For me, it was 6 business days.',
    likes: 3
  }]
}, {
  id: 8,
  name: 'Debra Peyton',
  image: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  time: '10h',
  content: "I should have bought it earlier. It's so nice to have the botanicals in Nymera working throughout the day, keeping my vessels supported. I take it every morning with breakfast, and it's made a huge difference—I no longer feel that awful heaviness halfway through the day.",
  likes: 11
}, {
  id: 9,
  name: 'Paula Remington',
  image: 'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  time: '12h',
  content: 'Wow, looks amazing. Does anyone actually have some and has it been tested?',
  likes: 2,
  replies: [{
    id: 91,
    name: 'Dr. Maria Castellanos',
    image: 'https://cdn.magicpatterns.com/uploads/h6aJiR4XXiJRW5ri8NK5g7/ChatGPT_Image_5_Φεβ_2026,_04_04_25_μ.μ..png',
    time: '6h',
    content: 'Hi Paula - Yes, Nymera is third-party tested for purity and potency. Every batch is verified. You can find the testing certificates on their website.',
    likes: 8,
    isAuthor: true
  }]
}, {
  id: 10,
  name: 'Sarah Dudley',
  image: 'https://images.unsplash.com/photo-1499952127939-9bbf5af6c51c?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  time: '14h',
  content: "The softgels are easy to take, and I really like how they're helping my legs. The natural ingredients in Nymera work wonders, especially during those afternoons when I usually feel my legs getting heavy—it really keeps me going and helps me feel more comfortable. 😊",
  likes: 7
}, {
  id: 15,
  name: 'Chris Thompson',
  image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  time: '15h',
  content: 'I just ordered mine! Cannot wait for it.',
  likes: 5
}, {
  id: 16,
  name: 'Barbara Bradley',
  image: 'https://images.unsplash.com/photo-1544717305-2782549b5136?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  time: '16h',
  content: "I need these, I'm gonna buy some this weekend when my paycheck hits lol!!",
  likes: 4
}, {
  id: 17,
  name: 'Ethel Dean',
  image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  time: '18h',
  content: 'Does anyone know how long the shipping takes? Want to buy some for my sister.',
  likes: 3,
  replies: [{
    id: 171,
    name: 'Clark Milton',
    image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    time: '4h',
    content: 'Hey Ethel, mine arrived after about a week.',
    likes: 2
  }, {
    id: 172,
    name: 'Emma Shelby',
    image: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    time: '48 min',
    content: 'Your sister will be happy!',
    likes: 6
  }]
}, {
  id: 13,
  name: 'Harry Keegan',
  image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  time: '1d',
  content: "The softgels are super convenient — easy to take anywhere, and you can tell they're made with quality ingredients. I've tried compression, massage, elevation, and even prescription diuretics, but this has been the most effective and easiest to stick with. It's more affordable than massage therapy too and does exactly what it says. Shipping was fast, and my wife loves it as much as I do!",
  likes: 14
}, {
  id: 18,
  name: 'Howard Mitchell',
  image: 'https://images.unsplash.com/photo-1504257432389-52343af06ae3?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  time: '1d',
  content: 'Love these softgels totally!',
  likes: 8
}, {
  id: 14,
  name: 'Anna Madison',
  image: 'https://images.unsplash.com/photo-1558898479-33c0057a5d12?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  time: '1d',
  content: "I was a skeptic... but I bought a bottle and was positively surprised. This is worth it. I've been struggling with heavy legs and constant afternoon swelling for a while, and it was starting to affect my daily life. Nymera helped me out a lot. My energy levels are so much better now because I'm not fighting my legs all day. Thank you to the company that made this.",
  likes: 13
}, {
  id: 19,
  name: 'Eddie Orson',
  image: 'https://images.unsplash.com/photo-1463453091185-61582044d556?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  time: '2d',
  content: "I absolutely love my Nymera! I had to order another bottle for my daughter today since she won't stop using mine!",
  likes: 10
}, {
  id: 20,
  name: 'Isabella Mason',
  image: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  time: '2d',
  content: 'OMG, I know! I was so happy they still had some in stock today. I had to order a bottle immediately before they run out again like last time.',
  likes: 7
}, {
  id: 24,
  name: 'Katherine Wells',
  image: 'https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  time: '2d',
  content: "Has anyone tried this with lipedema specifically? That's what I have and I'm curious.",
  likes: 5,
  replies: [{
    id: 241,
    name: 'Jennifer Adams',
    image: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    time: '1d',
    content: "Yes! I have lipedema and I've been using it for about 2 months. It doesn't make the lipedema go away (nothing does), but my legs feel SO much better throughout the day. Less heaviness, less aching. It's been really helpful for me.",
    likes: 18
  }, {
    id: 242,
    name: 'Patricia Williams',
    image: 'https://images.unsplash.com/photo-1589156280159-27698a70f29e?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    time: '1d',
    content: "Same here. I have Stage 2 lipedema and this has helped more than anything else I've tried for the daily swelling pattern. My compression therapist even noticed the difference.",
    likes: 12
  }]
}, {
  id: 21,
  name: 'Rachel Green',
  image: 'https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  time: '2d',
  content: 'Can you take this while pregnant?',
  likes: 3,
  replies: [{
    id: 211,
    name: 'Dr. Maria Castellanos',
    image: 'https://cdn.magicpatterns.com/uploads/h6aJiR4XXiJRW5ri8NK5g7/ChatGPT_Image_5_Φεβ_2026,_04_04_25_μ.μ..png',
    time: '1d',
    content: "Hi Rachel - I don't recommend taking any new supplements during pregnancy without your OB-GYN's approval. Please check with your doctor first.",
    likes: 9,
    isAuthor: true
  }]
}, {
  id: 12,
  name: 'Melissa Carter',
  image: 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  time: '3d',
  content: "I'm on my third bottle and I'm never stopping. This is the only thing that's actually helped with the afternoon heaviness. I used to have to leave work early some days because my legs hurt so bad. Haven't had to do that once since starting Nymera.",
  likes: 16
}, {
  id: 22,
  name: 'Sandra Lopez',
  image: 'https://images.unsplash.com/photo-1557862921-37829c790f19?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  time: '3d',
  content: 'Is this available in Canada?',
  likes: 2,
  replies: [{
    id: 221,
    name: 'Thomas Reed',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    time: '2d',
    content: "Yes! They ship to Canada. I'm in Toronto and got mine in about 10 days.",
    likes: 4
  }]
}, {
  id: 23,
  name: 'Nicole Harris',
  image: 'https://images.unsplash.com/photo-1534751516642-a1af1ef26a56?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  time: '3d',
  content: 'Just received mine today. Starting tomorrow morning. Will report back in a few weeks!',
  likes: 11
}];
function CommentItem({
  comment,
  isReply = false
}: {
  comment: Comment;
  isReply?: boolean;
}) {
  return <div className={`flex gap-3 ${isReply ? 'ml-8 mt-3' : ''}`} data-id="element-441">
      <img src={comment.image} alt={comment.name} className={`rounded-full object-cover border border-gray-200 flex-shrink-0 ${isReply ? 'w-8 h-8' : 'w-10 h-10'}`} data-id="element-442" />
      <div className="flex-1 min-w-0" data-id="element-443">
        <div className={`rounded-2xl px-4 py-3 ${comment.isAuthor ? 'bg-[#21afa1]/10' : 'bg-gray-100'}`} data-id="element-444">
          <div className="flex items-center gap-2 flex-wrap" data-id="element-445">
            <span className="font-bold text-sm text-gray-900" data-id="element-446">
              {comment.name}
            </span>
            {comment.isAuthor && <span className="text-xs bg-[#0d5d55] text-white px-1.5 py-0.5 rounded" data-id="element-447">
                Author
              </span>}
          </div>
          <p className="text-sm text-gray-800 mt-1" data-id="element-448">{comment.content}</p>
        </div>

        <div className="flex items-center gap-3 mt-1 ml-2 text-xs text-gray-500" data-id="element-449">
          <button className="font-semibold hover:underline" data-id="element-450">Like</button>
          <span data-id="element-451">•</span>
          <button className="font-semibold hover:underline" data-id="element-452">Reply</button>
          <span data-id="element-453">•</span>
          <span className="flex items-center gap-1" data-id="element-454">
            <ThumbsUp className="w-3 h-3" data-id="element-455" />
            {comment.likes}
          </span>
          <span data-id="element-456">•</span>
          <span data-id="element-457">{comment.time}</span>
        </div>

        {comment.replies && comment.replies.map(reply => <CommentItem key={reply.id} comment={reply} isReply data-id="element-458" />)}
      </div>
    </div>;
}
export function CommentSection() {
  return <section className="border-t border-gray-200 pt-8 pb-24" data-id="element-459">
      <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-460">Comments</h3>

      {/* Add comment input */}
      <div className="flex gap-3 mb-8 pb-6 border-b border-gray-100" data-id="element-461">
        <div className="w-10 h-10 rounded-full bg-gray-200 flex-shrink-0" data-id="element-462"></div>
        <input type="text" placeholder="Add a comment..." className="flex-1 bg-gray-100 rounded-full px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#21afa1]" data-id="element-463" />
      </div>

      <div className="space-y-6" data-id="element-464">
        {comments.map(comment => <CommentItem key={comment.id} comment={comment} data-id="element-465" />)}
      </div>

      <div className="mt-8 text-center" data-id="element-466">
        <button className="text-[#0d5d55] font-semibold text-sm hover:underline" data-id="element-467">
          View more comments
        </button>
      </div>
    </section>;
}